import axiosInstance from "../AxiosInstance";

export default class ExamScheduleRepository {
  static async getExamLists(queryString = "") {
    let result = {
      status: false,
      data: null,
    };
    try {
      const response = await axiosInstance.get(
        `/management/group/exam-requests/?` + queryString
      );
      if (response.status === 200) {
        result = { ...result, status: true, data: response.data };
      }
    } catch (e) {
      result = {
        ...result,
        nonFieldErrors: e.response.data
          ? e.response.data.data.error
          : "Ma'lumot olib bo'lmadi!",
      };
    }
    return result;
  }
}
